define(["require", "exports", "jquery", "knockout", "log", "../../utils/tools", "../../utils/kendoUtils", "../../models/UserContext", "./phoneNumberActions"], function (require, exports, $, ko, log, tools, KendoUtils, UserContext, PhoneNumberActions) {
    "use strict";
    var PhoneNumberTester = /** @class */ (function () {
        function PhoneNumberTester() {
            this.resulModel = ko.observable();
            this.hasResults = ko.observable(false);
            this.importFinished = ko.observable(false);
            this.phoneActions = new PhoneNumberActions();
            this.lastError = "";
            this.isImportValid = false;
            this.importData = [];
            this.providerId = ko.observable(-1);
        }
        PhoneNumberTester.prototype.init = function () {
        };
        PhoneNumberTester.prototype.openPhoneNumbersTester = function () {
            var self = this;
            self.resulModel = ko.observable();
            self.hasResults(false);
            self.importFinished(false);
            tools.editModal({
                title: "Phone Numbers Tester",
                buttonTitle: "Get Report",
                modalClass: "full-width",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (self.importData.length <= 0) {
                        tools.error("Data is empty");
                        return;
                    }
                    if (!self.providerId()) {
                        tools.error("Select Phone Numbers Provider");
                        return;
                    }
                    $(event.currentTarget).button('loading');
                    self.processNumbersImport(event.currentTarget, modal, null);
                },
                opened: function (modal) {
                    self.importData = [];
                    // Get lookup data:
                    var getLookupData = tools.ajaxGet({
                        url: "/PhoneNumbers/GetTestPhoneLookupData",
                        success: function (data) {
                            if (data.Success) {
                                self.lookupLists = data.Data.lookupLists;
                            }
                            else {
                                log.error(data.Error);
                            }
                        }
                    });
                    $.when(getLookupData).done(function (lookupData, data) {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'number-tester-template', self }\"></div>");
                        ko.applyBindings(self, modal);
                        self.initImportPhonesGrid(self.lookupLists.GridStructures.PhoneNumbersTesterList);
                    });
                }
            });
        };
        PhoneNumberTester.prototype.initImportPhonesGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "65px",
                template: function (dataItem) {
                    var html = "";
                    if (UserContext.hasAccess("Admin,PhoneNumbers.Edit,PhoneNumbers.Delete")) {
                        html += '<a class="btn btn-sm btn-info btn-edit" href="#"><i class="fa fa-edit "></i></a>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.phoneNumbersPreviewTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    //data: self.importData,
                    transport: {
                        read: function (options) {
                            options.success(self.importData);
                        },
                        create: function (options) {
                            self.importData.push(options.data);
                            options.success(options.data);
                        },
                        update: function (options) {
                            var dataItem = ko.utils.arrayFirst(self.importData, function (item) {
                                return item.Id === options.data.Id;
                            });
                            if (dataItem) {
                                $.extend(dataItem, options.data);
                            }
                            options.success(options.data);
                        },
                        destroy: function (options) {
                            var dataRow = ko.utils.arrayFirst(self.importData, function (item) { return item.Id === options.data.Id; });
                            ko.utils.arrayRemoveItem(self.importData, dataRow);
                            options.success(options.data);
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                        data: "",
                        total: function (result) {
                            result = result.data || result;
                            return result.length || 0;
                        }
                    },
                    serverFiltering: false,
                    serverPaging: false,
                    serverSorting: false
                },
                gridOptions: {
                    toolbar: kendo.template($("#number-tester-toolbar").html()),
                    height: 500,
                    columns: columns,
                    reorderable: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row menu",
                        extra: true
                    },
                    dataBound: function (e) {
                        var dataItems = e.sender.dataSource.view();
                        for (var j = 0; j < dataItems.length; j++) {
                            var error = dataItems[j].get("Error");
                            if (error) {
                                console.error(error);
                                var row = e.sender.tbody.find("[data-kendo-uid='" + dataItems[j].uid + "']");
                                row.addClass("alert-danger");
                            }
                        }
                    }
                },
                gridId: "phoneNumbersPreviewTable",
                enableExport: {
                    entityName: "PhoneNumber",
                    title: "Phone Numbers",
                    enablePdf: false
                }
            };
            self.phoneNumbersPreviewTable.initGrid(gridOptions);
            setTimeout(function () {
                self.phoneNumbersPreviewTable.refresh();
            });
            $("#phoneNumbersPreviewTable .btn-clear-rows").on("click", function (event) {
                var r = confirm("Are you sure you want to remove all rows");
                if (r) {
                    self.importData = [];
                    self.phoneNumbersPreviewTable.refresh();
                }
            });
            $("#phoneNumbersPreviewTable .btn-export").on("click", function (event) {
                var gridData = self.phoneNumbersPreviewTable.getGridData();
                gridData.saveAsExcel();
                event.preventDefault();
            });
            $("#phoneNumbersPreviewTable .k-grid-content").on("click", ".btn-remove", function (event) {
                KendoUtils.KendoUtils.removeGridRow(this);
                event.preventDefault();
            }).on("click", ".btn-edit", function (event) {
                var dataItem = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.phoneActions.editPhoneNumber(dataItem.PhoneNumberId, dataItem.Number, dataItem.CustomerId);
                event.preventDefault();
            }).on("paste", function (event) {
                var pastedText = undefined;
                if (window["clipboardData"] && window["clipboardData"].getData) { // IE
                    pastedText = window["clipboardData"].getData("Text");
                }
                else if (event.originalEvent["clipboardData"] && event.originalEvent["clipboardData"].getData) {
                    pastedText = event.originalEvent["clipboardData"].getData("text/plain");
                }
                setTimeout(function () {
                    // the pasted content
                    var value = $.trim(pastedText);
                    // get the pasted rows - split the text by new line
                    var rows = value.split("\n");
                    var maxId = 0;
                    ko.utils.arrayForEach(self.importData, function (item) {
                        maxId = item.Id > maxId ? item.Id : maxId;
                    });
                    maxId++;
                    for (var i = 0; i < rows.length; i++) {
                        // get the cells - split by tab
                        var cells = rows[i].split("\t");
                        self.addNewRecord({
                            Id: maxId++,
                            Number: cells[0].trim()
                        });
                    }
                    self.phoneNumbersPreviewTable.refresh();
                });
                return false; // Prevent the default handler from running.
            });
        };
        PhoneNumberTester.prototype.addNewRecord = function (record) {
            var self = this;
            var dataRow = ko.utils.arrayFirst(self.importData, function (item) { return item.Number === record.Number; });
            if (!dataRow) {
                // add a new item in the grid
                record.StatusId = 0;
                record.StatusName = '';
                record.IsValid = false;
                record.Error = '';
                record.ProviderId = 0;
                record.ProviderName = '';
                record.CustomerId = 0;
                record.CustomerName = '';
                record.PbxAccount = '';
                record.PbxDomain = '';
                record.PbxCustomerId = 0;
                record.PbxCustomerName = '';
                self.importData.push(record);
            }
        };
        PhoneNumberTester.prototype.processNumbersImport = function (btn, modal, callback) {
            var self = this;
            self.hasResults(false);
            var data = {
                providerId: self.providerId(),
                numbers: self.importData.map(function (x) { return x.Number; })
            };
            tools.ajaxPost({
                url: "/PhoneNumbers/TestPhoneNumbers",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    self.importData = result.Data;
                    self.phoneNumbersPreviewTable.refresh();
                }
                else {
                    tools.error(result.Error);
                }
                self.hasResults(result.Success);
                log.log(result);
            }).always(function () {
                $(btn).button("reset");
                self.importFinished(true);
            });
        };
        return PhoneNumberTester;
    }());
    return PhoneNumberTester;
});
//# sourceMappingURL=phoneNumberTester.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/phoneNumbers/phoneNumberTester.js
// module id = 211
// module chunks = 2